export const noneProjectSpecificUrl = [
  '/settings', // system setting
  '/projects/list',
  '/projects/create',
  // '/privacy',
  '/issue-list',
  '/guide',
  '/guide-shared',
  `/error?backTo=projectList`,
];
